export default __webpack_public_path__ + "static/media/flipkart_support-phone.04803cfd.svg";